export default __webpack_public_path__ + "static/media/velan-sir.fa6ebbd6.jpg";